export default () => localStorage.getItem('escenaStats') === 'true';



// WEBPACK FOOTER //
// ./src/utils/GetEnabledStats.js